import "./sprinkles.css.ts.vanilla.css-mistica.js";
import "./screen-reader-only.css.ts.vanilla.css-mistica.js";
var y = "gwdgwo1 _1y2v1nf5z _1y2v1nf78 _1y2v1nf8h _1y2v1nf9q _1y2v1nfb0 _1y2v1nfe5 _1y2v1nfdn";
export { y as screenReaderOnly };
